<template>
<layout>
  <div class="row">
    <div class="col-sm-6 col-md-4 col-md-offset-4">
      <div v-if="isPasswordChanged" class="alert alert-success" role="alert">
        パスワードを変更しました
      </div>
      <div v-if="errorResponse" class="alert alert-danger" role="alert">
        <ul>
          <li v-for="e in nonFieldErrors">{{ e }}</li>
          <li v-for="errors in fieldErrors" v-if="errors.length">
            {{ formLabels[$key] }}
            <ul>
              <li v-for="e in errors">{{ e }}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="account-wall">
        <form>
          <div class="form-group">
            <div v-bind:class="{'has-error': fieldErrors.oldPassword.length}">
              <input type="password"
                     class="form-control"
                     placeholder="{{ formLabels['oldPassword'] }}"
                     v-model="oldPassword"
                     required>
            </div>
          </div>
          <div class="form-group">
            <div v-bind:class="{'has-error': fieldErrors.newPassword.length}">
              <input type="password"
                     class="form-control"
                     placeholder="{{ formLabels['newPassword'] }}"
                     v-model="newPassword"
                     required>
            </div>
            <div class="has-feedback" v-bind:class="{'has-error': fieldErrors.newPassword.length, 'has-warning': !isPasswordMatched}">
              <input type="password"
                     class="form-control"
                     placeholder="{{ formLabels['confirmPassword'] }}"
                     v-model="confirmPassword"
                     required>
              <template v-if="!isPasswordMatched">
              <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true"></span>
              <span class="help-block">パスワードが一致していません</span>
              </template>
            </div>
          </div>
          <button class="btn btn-primary btn-block" type="submit" @click.prevent="changePassword">変更</button>
        </form>
      </div>
    </div>
  </div>
</layout>
</template>


<script lang="babel">
import moment from 'moment'
import ShopType from 'ShopType'
import Cookies from 'js.cookie'

export default {
  name: 'account-password',
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      isPasswordChanged: false,
      confirmPassword: null,
      errorResponse: null,
      formLabels: {
        oldPassword: '元のパスワード',
        newPassword: '新しいパスワード',
        confirmPassword: '新しいパスワード(確認用)',
      },
    }
  },
  computed: {
    nonFieldErrors() {
      if (this.errorResponse && this.errorResponse.body.nonFieldErrors) {
        return this.errorResponse.body.nonFieldErrors
      } else {
        return []
      }
    },
    fieldErrors() {
      let errors = {}
      let e = this.errorResponse ? this.errorResponse.body : {}

      Object.assign(errors, {
        oldPassword: e.oldPassword ? e.oldPassword : [],
        newPassword: e.newPassword ? e.newPassword : [],
      })

      return errors
    },
    isPasswordMatched() {
      return !this.newPassword && !this.confirmPassword || this.newPassword == this.confirmPassword
    },
  },
  methods: {
    changePassword() {
      if (!this.isPasswordMatched) {
        return
      }

      this.errorResponse = null
      this.isPasswordChanged = false

      let param = {oldPassword: this.oldPassword, newPassword: this.newPassword}
      this.apiPut(`/api/1.0/accounts/${this.account.pk}/password/`, param).then(response => {
        this.isPasswordChanged = true
        this.newPassword = null
        this.oldPassword = null
        this.confirmPassword = null
      }).catch(reason => {
        if (reason.error.status == 400) {
          this.errorResponse = reason.response
        }
      })
    },
  },
  mixins: [
    require('mixin/login-required.vue'),
    require('mixin/api-client.vue')
  ],
  components: {
    layout: require('layout.vue')
  },
}
</script>



// WEBPACK FOOTER //
// password.vue?8ce44a2e